import validate from 'validate.js';
import { DateTime } from 'luxon';

export function initValidation() {
  validate.extend(validate.validators.datetime, {
    parse: function(value) {
      return DateTime.fromISO(value);
    },
    format: function(value, options) {
      const format = options.dateOnly ? "dd.MM.yyyy" : "dd.MM.yyyy HH:mm:ss";
      return DateTime.fromISO(value).toFormat(format);
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/validate.js